import { Action } from "@reduxjs/toolkit";
import { MemberState } from "./types";
import { isType } from "typescript-fsa";
import { memberActions } from "./actions";

const initialState: MemberState = {
  members: [],
  selectedMember: null,
};

export function MemberReducer(
  state = initialState,
  action: Action
): MemberState {
  if (isType(action, memberActions.fetchMembers.done)) {
    return {
      ...state,
      members: action.payload.result.map((member) => ({
        id: member.id,
        username: member.username,
        email: member.email,
        role: member.role,
        last_login: member.last_login,
      })),
    };
  }

  if (isType(action, memberActions.getMemberDetails.done)) {
    return {
      ...state,
      selectedMember: action.payload.result,
    };
  }

  if (isType(action, memberActions.resetToInitialState)) {
    return initialState;
  }

  return state;
}
